<div
  #wrapper
  class="location-input-wrapper"
  tabindex="-1">
  <coin-v2-card
    padding="none"
    rounding="extra-large"
    [class.active]="hasFocus"
    [class.collapsed]="data?.sameAsEmployee">
    <div class="label">{{ 'gbr.location.same-label' | translate }}</div>

    <div
      class="main-part"
      (mousedown)="toggleEdit()">
      <p class="value">{{ selectionLabel }}</p>
      <div class="icon">
        <mat-icon>{{ hasFocus ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>
    </div>

    <div
      #editPart
      class="edit-part"
      tabindex="-1">
      <div class="yes-no-option">
        <div class="yes">
          <coin-v2-checkbox
            [ngModel]="$safeNavigationMigration(data?.sameAsEmployee)"
            [label]="'general.yes' | translate"
            (ngModelChange)="onSameToggle(!data?.sameAsEmployee)"></coin-v2-checkbox>
        </div>
        <div class="no">
          <coin-v2-checkbox
            [ngModel]="!data?.sameAsEmployee"
            [label]="'general.no' | translate"
            (ngModelChange)="onSameToggle(!data?.sameAsEmployee)"></coin-v2-checkbox>
        </div>
      </div>
      <div
        class="location-inputs"
        [class.active]="!data?.sameAsEmployee">
        @if (data && !data?.sameAsEmployee) {
          <coin-v2-text-input
            class="street"
            icon="edit"
            matFormFieldClass="shadow"
            [placeholder]="'gbr.entry' | translate"
            [label]="'gbr.location.street' | translate"
            [(ngModel)]="data.street" />
          <coin-v2-text-input
            class="number"
            icon="edit"
            matFormFieldClass="shadow"
            [placeholder]="'gbr.entry' | translate"
            [label]="'gbr.location.number' | translate"
            [(ngModel)]="data.number" />
          <coin-v2-number-input
            class="postalcode"
            svgIcon="edit"
            [placeholder]="'gbr.entry' | translate"
            [label]="'gbr.location.postalcode' | translate"
            [(ngModel)]="data.postalCode"></coin-v2-number-input>
        }
      </div>
    </div>
  </coin-v2-card>
</div>
